import { AccountType } from "component-library";

import config from "config/global";
import { MemberGroups, UmbracoTranslationsUserTypes } from "shared-types";

export const PROJECT_NAME = "JobsApp";

export const DEFAULT_LOCALE = "en-GB";
export const BASE_PATH = "/jobs";
export const SCROLLING_CONTAINER_ID = "scrollingContainer";
export const PAGINATION_PAGE_RANGE_MOBILE = 2;
export const PAGINATION_PAGE_RANGE_DESKTOP = 7;
export const DEFAULT_CLIENT_AGENCY_ID = 50;
export const NO_CLIENT_AGENCY_ID = -1;
export const JOB_UPDATE_NAVIGATION_DELAY = 2000;
export const ONE_DAY = 1000 * 60 * 60 * 24;
export const USE_BROWSER_BACK_KEY = "useBrowserBack";

export enum ErrorCode {
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  UnprocessableEntity = 422,
  InternalServerError = 500,
}

export const ACCOUNT_TYPE_GTM_MAPPING = {
  [AccountType.Agent]: config.gtm.accountTypes.agent,
  [AccountType.Performer]: config.gtm.accountTypes.performer,
};

export const ENDPOINT_SEGMENT_BY_USER_TYPE = {
  [MemberGroups.agent]: UmbracoTranslationsUserTypes.AgentsClassic,
  [MemberGroups.castingDirector]: UmbracoTranslationsUserTypes.CastingClassic,
  [MemberGroups.performer]: UmbracoTranslationsUserTypes.PerformersClassic,
  [MemberGroups.graduatePerformer]:
    UmbracoTranslationsUserTypes.GraduateClassic,
};

export const ENDPOINT_SEGMENT_BY_USER_TYPE_PREMIER = {
  [MemberGroups.performer]: UmbracoTranslationsUserTypes.AddOnBundle,
};

export enum ErrorPopupType {
  System = "systemError",
  Account = "accountError",
  Access = "accountAccessError",
  Network = "networkError",
}

export enum PageTitleKey {
  JobsFeedMatchingMySettings = "jobsFeedMatchingMySettings",
  JobsFeedAllOpportunities = "jobsFeedAllOpportunities",
  JobsFeedProjects = "jobsFeedProjects",
  JobsFeedAllPaid = "jobsFeedAllPaid",
  JobsFeedSelfTapeRequests = "jobsFeedSelfTapeRequests",
  FollowUp = "followUp",
  Breakdown = "breakdown",
  Role = "role",
  SelfTapeAddVideo = "selfTapeAddVideo",
  SelfTapeRequest = "selfTapeRequest",
  AgentQuickSearch = "agentQuickSearch",
}
